import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface mutateProps {
  ocpId: string;
  receiptId: string;
  data: any;
}

const mutateAddOCPFeeDoc = async ({
  ocpId,
  receiptId,
  data,
}: mutateProps) => {
  return await axiosAuth.post(
    `${OWNERSHIP_CHANGE_PACKET}/${ocpId}/fee-receipts/${receiptId}/proof`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useAddOCPFeeDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddOCPFeeDoc,
    ...queryParams,
  });

export default useAddOCPFeeDocMutation;
